// Form Builder Types and Interfaces

export type FormFieldType = 
  | 'text' 
  | 'textarea' 
  | 'number' 
  | 'select' 
  | 'multiselect' 
  | 'radio' 
  | 'checkbox' 
  | 'date' 
  | 'email' 
  | 'phone' 
  | 'scale' 
  | 'yes_no';

export interface FormFieldDefinition {
  id: string; // Unique field ID
  field_name: string; // Technical field name (e.g., 'monthly_income')
  label: string; // Display label (e.g., 'הכנסה חודשית')
  type: FormFieldType;
  description?: string; // Help text
  placeholder?: string;
  options?: string[]; // For select, multiselect, radio
  required?: boolean;
  validation?: {
    min?: number;
    max?: number;
    pattern?: string;
    errorMessage?: string;
  };
  conditionalLogic?: {
    showIf?: {
      field: string;
      operator: 'equals' | 'notEquals' | 'contains' | 'greaterThan' | 'lessThan';
      value: any;
    };
  };
  order: number; // Display order
}

export interface IntakeFormTemplate {
  id: string; // Firestore document ID
  name: string; // Form name (e.g., 'Rights Intake Form')
  nameHe?: string; // Hebrew name
  nameEn?: string; // English name
  description?: string;
  type: 'rights' | 'emotional' | 'professional' | 'custom'; // Form category
  customType?: string; // For custom forms, user-defined type
  fields: FormFieldDefinition[];
  isActive: boolean; // Whether the form is currently active
  isDefault?: boolean; // Whether this is a default system form
  createdBy: string; // User email who created it
  createdAt: string; // ISO timestamp
  updatedBy?: string;
  updatedAt?: string;
  version: number; // Version tracking for updates
  sharedWith: 'all' | 'specific'; // Sharing settings
  organizationId?: string; // If shared with specific organization
  allowedRoles?: string[]; // Roles that can use this form
}

export interface FormSubmission {
  id: string;
  formId: string; // Reference to IntakeFormTemplate
  formVersion: number; // Which version of the form was used
  caseId: string; // Patient case ID
  answers: { [fieldName: string]: any };
  completedBy: string; // User email
  completedAt: string; // ISO timestamp
  updatedAt?: string;
  status: 'draft' | 'completed';
}

// Roles that can create/edit forms - ONLY super_admin
export const FORM_MANAGEMENT_ROLES = [
  'super_admin'
];

export function canManageForms(userRole?: string): boolean {
  if (!userRole) return false;
  return FORM_MANAGEMENT_ROLES.includes(userRole);
}

